import { render } from "./ItemTable.vue?vue&type=template&id=18b894e8"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__